import { UseFormReset } from 'react-hook-form';

import { FormProvider } from 'core/states';
import { PricingProfilePricingType } from 'pricing/enums';
import { usePricingProfileActions } from 'pricing/hooks';
import { mapUpsertPricingProfile } from 'pricing/mappers';
import { IPricingProfile, IPricingProfileForm } from 'pricing/types';

import { AddPricingProfileFormFields } from './AddPricingProfileFormFields';
import { pricingProfileCreateSchema } from './schema';

interface IProps {
  type?: PricingProfilePricingType;
  isOpen?: boolean;
  onClose: () => void;
  onSubmitSuccess: (pricingProfile?: IPricingProfile) => void;
  level?: number;
  defaultName?: string;
  withValidityDates?: boolean;
}

export const AddPricingProfile = ({
  type = PricingProfilePricingType.PRICING,
  isOpen = false,
  onClose,
  onSubmitSuccess,
  level,
  defaultName,
  withValidityDates = false,
}: IProps) => {
  const { upsertPricingProfile } = usePricingProfileActions({ type });

  const onSubmit =
    (reset: UseFormReset<IPricingProfileForm>) => async (data: IPricingProfileForm) => {
      const { success, pricingProfile } = await upsertPricingProfile(
        mapUpsertPricingProfile(type, data)
      );

      if (!success) {
        return;
      }

      setTimeout(() => {
        onSubmitSuccess(pricingProfile);
        handleOnClose(reset);
      }, 1000);
    };

  const handleOnClose = (reset?: UseFormReset<IPricingProfileForm>) => {
    onClose();
    reset?.({
      name: null,
      agreementId: null,
      shareAccess: false,
    });
  };

  if (!isOpen) {
    return null;
  }

  return (
    <FormProvider schema={pricingProfileCreateSchema()}>
      <AddPricingProfileFormFields
        type={type}
        isOpen={isOpen}
        onClose={handleOnClose}
        onSubmit={onSubmit}
        level={level}
        defaultName={defaultName}
        withValidityDates={withValidityDates}
      />
    </FormProvider>
  );
};
